import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@stvgroup/stv-ui-components'
import { assetPrefix } from '../../stv.config'
import styles from './styles'
import buildQueryString from '../../utils/buildQueryString'

const playerQueryString = (autoplayShortform) => {
  const {
    videoId, drmEnabled, guid, videoLength,
  } = autoplayShortform || {}

  const queryParams = {
    videoId,
    drmEnabled,
    videoGuid: guid,
    videoLength,
  }

  return buildQueryString(queryParams)
}

const PreviewPlayer = (props) => {
  const {
    playing,
    autoplayShortform,
  } = props

  const videoQueryString = playerQueryString(autoplayShortform)

  return (
    <Box
      className="PreviewPlayer"
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
        opacity: playing ? 1 : 0,
        transition: 'opacity 0.3s',
        '& .controls': {
          display: 'none',
        },
      }}
    >
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <iframe
        className="preview-iframe"
        data-testid="preview-iframe"
        name="stv-preview-iframe"
        scrolling="no"
        src={`${assetPrefix}/players/preview${videoQueryString}`}
        allowFullScreen
        allow="encrypted-media"
        muted
      />
      <style jsx>{styles}</style>
    </Box>
  )
}

PreviewPlayer.propTypes = {
  playing: PropTypes.bool,
  autoplayShortform: PropTypes.shape({
    videoId: PropTypes.number,
    drmEnabled: PropTypes.bool,
    title: PropTypes.string,
    videoGuid: PropTypes.string,
    videoLength: PropTypes.number,
  }),
}

PreviewPlayer.defaultProps = {
  playing: false,
  autoplayShortform: null,
}

export default PreviewPlayer
